import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, type SxProps, type Theme } from '@mui/material'
import { NeighboursIcon } from '@dhl-ui/icons'
import { Body1 } from '@dhl-ui/components'

type Props = {
  sx?: SxProps<Theme>
}

export const DisplayNeighbourValue: FC<Props> = ({ sx }) => {
  const { t } = useTranslation()
  return (
    <Stack gap={1} data-test="neighbours-description" sx={sx}>
      <Body1 component="span">{t('portal.preferences.neighbours.afterNotHome.descriptionValue')}</Body1>
      <Box display="flex" flexDirection="row">
        <NeighboursIcon sx={{ mr: 1 }} />
        <Body1 component="span">{t('portal.preferences.neighbours.afterNotHome.defaultValue')}</Body1>
      </Box>
    </Stack>
  )
}
